import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../utils/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount, load token
  useEffect(() => {
    const token = localStorage.getItem('employer_token');
    if (!token) {
      setLoading(false);
      return;
    }
    // TODO: Could fetch profile, for now assume logged in
    const storedUser = JSON.parse(localStorage.getItem('employer_profile') || 'null');
    setUser(storedUser);
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/employers/login', { email, password });
    const { token, employer } = res.data;
    localStorage.setItem('employer_token', token);
    localStorage.setItem('employer_profile', JSON.stringify(employer));
    setUser(employer);
  };

  const register = async (formData) => {
    await api.post('/employers/register', formData);
    // return message; employer must await approval
  };

  const logout = () => {
    localStorage.removeItem('employer_token');
    localStorage.removeItem('employer_profile');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext); 